app.controller('BrowseRangeInfoRangeController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const navigationIDs = $scope.navigation_ids;
    const requestRangeID = navigationIDs.request_range_id;
    const rangeInfoID = navigationIDs. range_info_id;

    const siteRangeID = navigationIDs.site_range_id;
    if(requestRangeID && siteRangeID){
        const variationIDs = {browse_id: "site_range", request_range_id: requestRangeID, site_range_id: siteRangeID};

        const siteRangeModel = $rootScope.factory.site_range.getModel(variationIDs);
        const colourModel = $rootScope.factory.colour.getModel(variationIDs);
        const styleModel = $rootScope.factory.style.getModel(variationIDs);
        const siteRangeChoice = siteRangeModel.choices[siteRangeID]

        $scope.colour_choice_list = colourModel.choiceList()
        $scope.style_choice_list = styleModel.choiceList()
        $scope.site_range_choice = siteRangeChoice;
    } else {
        $scope.colour_choice_list = []
        $scope.style_choice_list = []
        $scope.site_range_choice = null;
    }

    $scope.product_documents = [];

    $rootScope.service.cache_local_server.productDocumentsByTags(["range_info", siteRangeID ? siteRangeID : rangeInfoID], function (documents) {

        documents = JSON.parse(JSON.stringify(documents));
        for (let i = 0; i < documents.length; i++) {
            const document = documents[i];
            document.is_range_generic = false;
            if (document.product_tags) {
                if (document.product_tags.range_generic) {
                    document.is_range_generic = true;
                }
            }
        }

        documents.sort(function (a, b) {
            if (!a.is_range_generic && b.is_range_generic) {
                return -1;
            }
            if (a.is_range_generic && !b.is_range_generic) {
                return 1;
            }
        })
        $scope.product_documents = documents;
    })


}]);